// Where am I, and the way back: "Money › Receivables" with each step a link, and "← Back" — the browser's back when the
// person came from inside the app (so the place, filters and drill they left are as they were), else one step up.
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

export interface Step { label: string; to?: string | undefined }
export function Trail({ items }: { items: Step[] }) {
  const nav = useNavigate();
  const up = [...items].reverse().find((s, i) => i > 0 && s.to)?.to ?? items[0]?.to ?? '/group';
  const back = () => { const idx = (typeof window !== 'undefined' ? (window.history.state as { idx?: number } | null)?.idx : 0) ?? 0; if (idx > 0) nav(-1); else nav(up); };
  return <nav className="crumbs trail" aria-label="Where you are">
    <button type="button" className="link back" onClick={back}>← Back</button>
    {items.map((c, i) => <span key={i}>{c.to && i < items.length - 1 ? <Link to={c.to}>{c.label}</Link> : <b aria-current={i === items.length - 1 ? 'page' : undefined}>{c.label}</b>}{i < items.length - 1 && <span className="sep">›</span>}</span>)}
  </nav>;
}
